module.exports = __webpack_public_path__ + "static/media/bg.6bd0d43b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg.png
// module id = 978
// module chunks = 0